import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * for this page
 */
import Table from './table';
import TabTitle from '../../../../components/tabTitle';

class MrtsTable extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        current: this.props.content.current,
    };

    handleMouseOver = index => {
        if (index !== this.state.current) {
            this.setState({
                current: index,
            });
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { title, tabTits, tableTits, data } = this.props.content;
        const { current } = this.state;

        return (
            <div className={styles.tab}>
                <TabTitle title={title} tabTits={tabTits} current={current} callback={this.handleMouseOver} />
                <div className={styles.table}>
                    <Table
                        content={{
                            key: current,
                            tit: tableTits[current],
                            data: data[current],
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default errorBoundary(MrtsTable);
